module.exports = __webpack_public_path__ + "img/photo-1-2.c8d7f0fa.jpg";